import { pick } from "lodash";
import { Button } from "PFComponents/button";
import { useCustomization } from "PFCore/hooks/queries/accounts/use_customization";
import { Id, LocalisationKeys } from "PFTypes";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "../localisation.module.scss";
import { ExportModal } from "./export_modal";
import { ImportModal } from "./import_modal";

type LocalisationExportProps = {
  accountId?: Id;
  localisationKey: LocalisationKeys;
};

export const LocalisationExport = ({ accountId, localisationKey }: LocalisationExportProps) => {
  const { t } = useTranslation("admin");

  const { data: localesData } = useCustomization(Number(accountId), {
    enabled: !!accountId
  });

  const { allowedLocales } = useMemo(() => pick(localesData, "allowedLocales"), [localesData]);

  const [isImportModalVisible, handleImportModalVisibility] = useState(false);
  const [isExportModalVisible, handleExportModalVisibility] = useState(false);

  return (
    <span className={css.exportButtons}>
      <Button
        icon="import"
        text={t("localisation.import")}
        kind="secondary"
        onClick={() => handleImportModalVisibility(true)}
      />
      <Button
        icon="export"
        text={t("localisation.export")}
        kind="secondary"
        onClick={() => handleExportModalVisibility(true)}
      />
      {isImportModalVisible && (
        <ImportModal
          accountId={accountId}
          onClose={() => handleImportModalVisibility(false)}
          localisationKey={localisationKey}
          onExportModalOpen={() => {
            handleImportModalVisibility(false);
            handleExportModalVisibility(true);
          }}
        />
      )}
      {isExportModalVisible && (
        <ExportModal
          accountId={accountId}
          localisationKey={localisationKey}
          allowedLocales={allowedLocales || []}
          onClose={() => handleExportModalVisibility(false)}
        />
      )}
    </span>
  );
};
